import { Lightbulb, TrendingUp, Target } from 'lucide-react';
import { Link } from 'react-router-dom';

const features = [
  {
    icon: Lightbulb,
    title: 'Network-Powered Expertise',
    description:
      'Collective intelligence, not a single operator. One embedded leader, backed by a trusted network of seasoned operators. Peer insight, specialist reachback and a shared experience that no solo practitioner can match.',
  },
  {
    icon: TrendingUp,
    title: 'Leadership That Scales With You',
    description:
      'From board advisory to full operational ownership. Scale up during periods of change, scale down when steady. Predictable investment, no surprises.',
  },
  {
    icon: Target,
    title: 'Business-Aligned Security',
    description:
      'Focused on operational resilience, regulatory confidence, customer assurance and audit pressure reduction. Security as a business enabler, not blocker.',
  },
  {
    icon: Target,
    title: 'Board-Ready Guidance',
    description:
      'Calm, experienced executive cyber counsel at the Board level. Helping non-technical directors ask the right questions and make informed decisions under pressure.',
  },
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-white scroll-smooth-section">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-up">
          <span className="text-xs font-medium text-secondary tracking-[0.2em] uppercase">
            Our Services
          </span>
          <div className="mx-auto mt-4 mb-5 h-px w-12 bg-secondary/40" />
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground tracking-tight mb-4">
            All You Need From a CISO
          </h2>
          <p className="text-muted-foreground max-w-3xl mx-auto text-lg">
            Our fractional CISOs bring the same strategic capability as a full-time hire, flexibly
            deployed to reduce your risk exposure and match your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {features.map((feature, i) => (
            <div
              key={i}
              className="group text-center opacity-0"
              style={{
                animation: `fade-up 0.6s ease-out forwards`,
                animationDelay: `${i * 0.12}s`,
              }}
            >
              <div className="h-16 w-16 rounded-2xl bg-teal flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <feature.icon className="h-8 w-8 text-accent-foreground" />
              </div>

              <h3 className="text-xl font-heading font-bold text-foreground mb-3 group-hover:text-secondary transition-colors duration-300">
                {feature.title}
              </h3>

              <p className="text-muted-foreground leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/services" className="btn-secondary-custom">
            Read More About Our Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Services;
